import { ACTION_TYPE } from '../../constants'
import { GtmBaseModel } from '../gtm-base.model/gtm-base.model'

export class GtmTasksClickModel extends GtmBaseModel {
  constructor() {
    super()
    this.action_type = ACTION_TYPE.CLICK_TASKS
  }
}
